/*
 feedback.js <http://experiments.hertzen.com/jsfeedback/>
 Copyright (c) 2012 Niklas von Hertzen. All rights reserved.
 http://www.twitter.com/niklasvh

 Released under MIT License

 WARNING: This library is customized, do not upgrade the library without consulting

 What changed:
    -- ignore classes
    -- customized report form
    -- additional data sent to help diagonise problems
    -- this library requires IE9+ and modern web browsers, with jQuery and Session.js as
       dependencies.

 Sheldon Rong, July 23rd, 2013
 Updates: Oct 21th, 2013
*/

(function(window, document, undefined) {
'use strict';
var T_ = function(text) { return text; };

var jQuery = window.jQuery;
var _ = window._;
var html2canvas = window.html2canvas;
// This will be initialised on construction
var isLoggedIn;


if (window.Feedback !== undefined) {
    return;
}

// log proxy function
var log = function(msg) {
    window.console.log(msg);
},
// function to remove elements, input as arrays
removeElements = function(remove) {
    for (var i = 0, len = remove.length; i < len; i++) {
        var item = Array.prototype.pop.call(remove);
        if (item !== undefined) {
            if (item.parentNode !== null) { // check that the item was actually added to DOM
                item.parentNode.removeChild(item);
            }
        }
    }
},
loader = function() {
    var div = document.createElement('div'), i = 3;
    div.className = 'feedback-loader';

    while (i--) { div.appendChild(document.createElement('span')); }
    return div;
},
getBounds = function(el) {
    return el.getBoundingClientRect();
},
emptyElements = function(el) {
    var item;
    while (((item = el.firstChild) !== null ? el.removeChild(item) : false)) {}
},
element = function(name, text) {
    var el = document.createElement(name);
    el.appendChild(document.createTextNode(text));
    return el;
},
// script onload function to provide support for IE as well
scriptLoader = function(script, func) {

    if (script.onload === undefined) {
        // IE lack of support for script onload

        if (script.onreadystatechange !== undefined) {

            var intervalFunc = function() {
                if (script.readyState !== 'loaded' && script.readyState !== 'complete') {
                    window.setTimeout(intervalFunc, 250);
                } else {
                    // it is loaded
                    func();
                }
            };

            window.setTimeout(intervalFunc, 250);

        } else {
            log("ERROR: We can't track when script is loaded");
        }

    } else {
        return func;
    }

},
nextButton,
H2C_IGNORE = 'data-html2canvas-ignore',
currentPage,
screenshot,
feedbackOptions,
modalBody = document.createElement('div');

window.Feedback = function(options) {

    options = options || {};

    isLoggedIn = options.isLoggedIn;

    // default properties
    options.label = options.label || T_('Report Bug');
    options.header = options.header || T_('Report Bug');
    options.url = options.url || '/';
    options.adapter = options.adapter || new window.Feedback.XHR(options.url);

    options.nextLabel = options.nextLabel || T_('Continue');
    options.reviewLabel = options.reviewLabel || T_('Review');
    options.sendLabel = options.sendLabel || T_('Send');
    options.closeLabel = options.closeLabel || T_('Close');

    feedbackOptions = options.feedbackOptions;

    options.messageSuccess = options.messageSuccess || T_('Thank you for sending us your feedback.');
    options.messageError = options.messageError || T_('There was an error sending your feedback to the server.');


    if (options.skipClass != 'undefined') {
        for (var i = options.skipClass.length - 1; i >= 0; i--) {
            jQuery('.' + options.skipClass[i]).hide();
        }
    }

    if (options.pages === undefined) {
        options.pages = [
            new window.Feedback.Form(),
            new window.Feedback.Review()
        ];
    }

    var button,
    modal,
    currentPage,
    glass = document.createElement('div'),
    runH2c = function() {
        try {

            options.onrendered = options.onrendered || function(canvas) {
                screenshot = canvas;
            };
            html2canvas([document.body], options);
            //html2canvas([ document.body ], options);

        } catch (e) {
            log('Error in html2canvas: ' + e.message);
        }
    },
    returnMethods = {

        // open send feedback modal window
        open: function() {
            var len = options.pages.length;
            currentPage = 0;
            for (; currentPage < len; currentPage++) {
                // create DOM for each page in the wizard
                if (!(options.pages[currentPage] instanceof window.Feedback.Review)) {
                    options.pages[currentPage].render();
                }
            }

            var a = element('a', '\xD7'),
            modalTitle = element('h3', options.header),
            // modal Container
            modalPinkyContainer = document.createElement('div'),
            // modal Inner
            modalInner = document.createElement('div'),
            modalHeader = document.createElement('div'),
            modalFooter = document.createElement('div');

            modal = document.createElement('div');
            document.body.appendChild(glass);

            // modal close button
            a.className = 'feedback-close';
            a.onclick = returnMethods.close;
            a.href = '#';

            button.disabled = true;

            modalTitle.className = 'modal-title';

            // build header element
            modalHeader.appendChild(a);
            modalHeader.appendChild(modalTitle);
            modalHeader.className = 'modal-header';

            modalBody.className = 'modal-body';

            emptyElements(modalBody);
            currentPage = 0;
            modalBody.appendChild(options.pages[currentPage++].dom);

            // Next button
            nextButton = element('button', options.nextLabel);

            nextButton.className = 'btn btn-info';
            nextButton.onclick = function() {

                if (currentPage > 0) {
                    if (options.pages[currentPage - 1].end(modal) === false) {
                        // page failed validation, cancel onclick
                        return;
                    }
                }

                emptyElements(modalBody);

                if (currentPage === len) {
                    returnMethods.send(options.adapter);
                } else {

                    options.pages[currentPage].start(modal, modalHeader, modalFooter, nextButton);

                    if (options.pages[currentPage] instanceof window.Feedback.Review) {
                        // create DOM for review page, based on collected data
                        options.pages[currentPage].render(options.pages);
                    }

                    // add page DOM to modal
                    modalBody.appendChild(options.pages[currentPage++].dom);

                    // if last page, change button label to send
                    if (currentPage === len) {
                        nextButton.firstChild.nodeValue = options.sendLabel;
                        if (screenshot !== undefined) {
                            var img = new Image();
                            img.src = screenshot.toDataURL();
                            img.style.width = '300px';
                            img.style.height = 'auto';
                            modalBody.appendChild(img);
                        }
                    }

                    // if next page is review page, change button label
                    if (options.pages[currentPage] instanceof window.Feedback.Review) {
                        nextButton.firstChild.nodeValue = options.reviewLabel;
                    }


                }

            };

            modalBody.firstChild.className = 'fl-form';

            modalFooter.className = 'modal-footer';
            modalFooter.appendChild(nextButton);

            modalPinkyContainer.className = 'pinky-template';
            modalInner.className = 'modal feedback-modal';
            modal.className = 'responsive-modal';

            modal.setAttribute(H2C_IGNORE, true); // don't render in html2canvas

            modalInner.appendChild(modalHeader);
            modalInner.appendChild(modalBody);
            modalInner.appendChild(modalFooter);

            modal.appendChild(modalInner);

            modalPinkyContainer.appendChild(modal);

            document.body.className = 'modal-open';
            document.body.appendChild(modalPinkyContainer);

            if (!(session.browser.browser === 'Explorer' &&
                (session.browser.version === 8 || session.browser.version === 9))) {
                runH2c();
            }
        },


        // close modal window
        close: function() {

            button.disabled = false;

            // remove feedback elements
            removeElements([modal, glass]);

            // remove class modal-open from body
            document.body.classList.remove('modal-open');

            // call end event for current page
            if (currentPage > 0) {
                options.pages[currentPage - 1].end(modal);
            }

            // call close events for all pages
            for (var i = 0, len = options.pages.length; i < len; i++) {
                options.pages[i].close();
            }

            //display those that are hidden because of skipClass
            if (options.skipClass != 'undefined') {
                for (var i = options.skipClass.length - 1; i >= 0; i--) {
                    jQuery('.' + options.skipClass[i]).show();
                }
            }
            return false;

        },

        // send data
        send: function(adapter) {

            // make sure send adapter is of right prototype
            if (!(adapter instanceof window.Feedback.Send)) {
                throw new Error('Adapter is not an instance of Feedback.Send');
            }

            // fetch data from all pages
            for (var i = 0, len = options.pages.length, data = [], p = 0, tmp; i < len; i++) {
                if ((tmp = options.pages[i].data()) !== false) {
                    data[p++] = tmp;
                }
            }

            nextButton.disabled = true;

            emptyElements(modalBody);
            var loader = document.createElement('div');
            loader.className = 'pinky-template';
            loader.style.padding = '10px';
            loader.style.textAlign = 'center';
            loader.style.minWidth = '0';
            loader.innerHTML = "<div class='loading-icon'><span class='fl-icon-spinner'></span></div>";
            modalBody.appendChild(loader);

            // send data to adapter for processing
            adapter.send(data, function(success, returnedData) {

                emptyElements(modalBody);
                nextButton.disabled = false;

                nextButton.firstChild.nodeValue = options.closeLabel;

                nextButton.onclick = function() {
                    returnMethods.close();
                    return false;
                };
                if (success === true && returnedData.status === 'success') {
                    modalBody.appendChild(document.createTextNode(options.messageSuccess));
                } else {
                    var errorText = options.messageError;
                    if (returnedData.hasOwnProperty('reason')) {
                        errorText = returnedData.reason;
                    }
                    modalBody.appendChild(document.createTextNode(errorText));
                }

            });

        }
    };

    glass.className = 'modal-backdrop';
    glass.style.pointerEvents = 'none';
    glass.setAttribute(H2C_IGNORE, true);

    options = options || {};

    button = element('button', options.label);
    button.className = 'feedback-btn feedback-bottom-right';

    button.setAttribute(H2C_IGNORE, true);

    button.onclick = returnMethods.open;

    if (options.appendTo !== null) {
        ((options.appendTo !== undefined) ? options.appendTo : document.body).appendChild(button);
    }

    return returnMethods;
};
window.Feedback.Page = function() {};
window.Feedback.Page.prototype = {

    render: function(dom) {
        this.dom = dom;
    },
    start: function() {},
    close: function() {},
    data: function() {
        // don't collect data from page by default
        return false;
    },
    review: function() {
        return null;
    },
    end: function() { return true; }

};
window.Feedback.Send = function() {};
window.Feedback.Send.prototype = {

    send: function() {}

};

window.Feedback.Form = function(elements) {

    if (isLoggedIn) {
        this.elements = elements || [{
            type: 'select',
            name: 'type',
            required: true,
            errorElement: document.createElement('p'),
            label: T_('Please select the type of issue you are experiencing'),
            options: feedbackOptions
        }, {
            type: 'textarea',
            name: 'issue',
            errorElement: document.createElement('p'),
            label: T_('Please describe the issue in detail'),
            required: true
        }];
    } else {
        this.elements = elements || [{
            type: 'select',
            name: 'type',
            required: true,
            errorElement: document.createElement('p'),
            label: T_('Please select the type of issue you are experiencing'),
            options: feedbackOptions
        }, {
            type: 'input',
            name: 'email',
            errorElement: document.createElement('p'),
            label: T_('Please provide your contact email'),
            required: true
        }, {
            type: 'textarea',
            name: 'issue',
            errorElement: document.createElement('p'),
            label: T_('Please describe the issue in detail'),
            required: true
        }];
    }

    this.dom = document.createElement('form');

};

window.Feedback.Form.prototype = new window.Feedback.Page();

window.Feedback.Form.prototype.render = function() {

    var item;
    emptyElements(this.dom);
    for (var i = 0; i < this.elements.length; i++) {
        item = this.elements[i];

        switch (item.type) {
            case 'textarea':
                this.dom.appendChild(element('label', item.label + ':' + ((item.required === true) ? ' *' : '')));
                item.element = document.createElement('textarea');
                item.element.setAttribute('maxlength', 1023);
                this.dom.appendChild(item.element);
                this.dom.appendChild(item.errorElement);
                break;
            case 'input':
                this.dom.appendChild(element('label', item.label + ':' + ((item.required === true) ? ' *' : '')));
                item.element = document.createElement('input');
                item.element.setAttribute('type', 'text');
                item.element.setAttribute('maxlength', 127);
                this.dom.appendChild(item.element);
                this.dom.appendChild(item.errorElement);
                break;
            case 'select':
                this.dom.appendChild(element('label', item.label + ':' + ((item.required === true) ? ' *' : '')));
                var select = document.createElement('select');
                for (var j = 0; j < item.options.length; j++) {
                    var option = document.createElement('option');
                    option.setAttribute('value', item.options[j].value);
                    option.innerHTML = item.options[j].name;
                    select.appendChild(option);
                }
                this.dom.appendChild(item.element = select);
                break;
        }
    }

    return this;

};

function validateEmail(email) {
    return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(email);
}

window.Feedback.Form.prototype.end = function() {
    // form validation
    var i = 0, len = this.elements.length, item;
    for (; i < len; i++) {
        item = this.elements[i];

        // check that all required fields are entered
        item.errorElement.innerHTML = '';
        if (item.required === true && item.element.value.length === 0) {
            item.element.className = 'feedback-error';
            item.errorElement.className = 'feedback-error';
            item.errorElement.innerHTML = 'Please input your ' + item.name;
            return false;
        } else {
            if (item.name === 'email' && !validateEmail(item.element.value)) {
                item.element.className = 'feedback-error';
                item.errorElement.className = 'feedback-error';
                item.errorElement.innerHTML = 'Please input a valid email address';
                return false;
            }
            item.element.className = '';
        }
    }

    return true;

};

window.Feedback.Form.prototype.data = function() {

    if (this._data !== undefined) {
        // return cached value
        return this._data;
    }

    var i = 0, len = this.elements.length, item, data = {};

    for (; i < len; i++) {
        item = this.elements[i];
        data[item.name] = item.element.value;
    }

    // cache and return data
    return (this._data = data);
};


window.Feedback.Form.prototype.review = function(dom) {

    var i = 0, item, len = this.elements.length;

    for (; i < len; i++) {
        item = this.elements[i];

        if (item.element.value.length > 0) {
            dom.appendChild(element('label', item.label + ':'));
            var data = '';
            switch (item.type) {
                case 'textarea':
                    data = item.element.value;
                    break;
                case 'input':
                    data = item.element.value;
                    break;
                case 'select':
                    data = item.options[item.element.value - 1].name;
                    break;
            }
            var answer = document.createElement('div');
            answer.className = 'user-feedback';
            answer.innerHTML = _.escape(data);
            dom.appendChild(answer);
        }
    }
    return dom;
};
window.Feedback.Review = function() {

    this.dom = document.createElement('div');
    this.dom.className = 'feedback-review';

};

window.Feedback.Review.prototype = new window.Feedback.Page();

window.Feedback.Review.prototype.render = function(pages) {

    var i = 0, len = pages.length, item;
    emptyElements(this.dom);

    for (; i < len; i++) {

        // get preview DOM items
        pages[i].review(this.dom);

    }

    return this;

};

window.Feedback.XHR = function(url) {

    this.xhr = new XMLHttpRequest();
    this.url = url;

};

window.Feedback.XHR.prototype = new window.Feedback.Send();

window.Feedback.XHR.prototype.send = function(data, callback) {

    var xhr = this.xhr;

    xhr.onreadystatechange = function() {
        if (xhr.readyState == 4) {
            callback(xhr.status === 200, window.JSON.parse(xhr.responseText));
        }
    };
    _.each(feedbackOptions, function(element, index) {
        if (element.value == data[0].type) {
            data[0]['typeName'] = element.name;
        }
    });
    //paste additional data that could benefit problem solving
    if (typeof session != 'undefined') {
        data[0]['browser'] = session.browser;
        data[0]['url'] = session.current_session.url;
        data[0]['device'] = session.device;
        data[0]['plugin'] = session.plugins;
    }

    if (!(session.browser.browser === 'Explorer' &&
                (session.browser.version === 8 || session.browser.version === 9))) {
        data[1] = screenshot.toDataURL();
    }
    xhr.open('POST', this.url, true);
    xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    xhr.send('data=' + encodeURIComponent(window.JSON.stringify(data)));

};
})(window, document);
